// Empire Jamaica Fusion — Private Events page data

export const EXPERIENCES = [
    {
        id: "birthdays",
        title: "Birthday Celebrations",
        note: "Milestone dinners and intimate parties — your favorite people, plated like a private dining room.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/akevgric_74098083-15F2-457E-8577-0FBE43FFCA51.PNG",
        guestRange: "8 – 60",
        accent: "from-burgundy/30",
    },
    {
        id: "anniversaries",
        title: "Anniversary Dinners",
        note: "Tasting menus, warm atmosphere, and slow service. Built for couples and the people who love them.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/vp3l83vv_69815085-246A-45C7-B581-5675DC197104.PNG",
        guestRange: "2 – 24",
        accent: "from-gold/20",
    },
    {
        id: "private-dining",
        title: "Private Dining",
        note: "Reserve the room. Custom menu. Curated playlist. A whole evening dedicated to your table.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/3a3gg55y_4F31409C-D6F5-4DDA-9779-4F8F44844AA6.PNG",
        guestRange: "12 – 60",
        accent: "from-burgundy/30",
    },
    {
        id: "milestones",
        title: "Family & Milestone Gatherings",
        note: "Reunions, engagements, retirements — the evenings that turn into the stories we tell forever.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/2j9ynage_Family_Gathering_event.PNG",
        guestRange: "10 – 80",
        accent: "from-gold/20",
    },
];

export const PROCESS = [
    {
        step: "01",
        title: "Tell us about your gathering",
        note: "Share the occasion, the date, the headcount and the feeling you want in the room. We listen first.",
    },
    {
        step: "02",
        title: "We curate your experience",
        note: "Bespoke menu, service style, beverage pairings, room layout, music. Quietly tailored to you.",
    },
    {
        step: "03",
        title: "Enjoy an unforgettable evening",
        note: "Soulful Caribbean cooking, attentive hospitality, and a room arranged so your guests feel held.",
    },
];

export const GALLERY = [
    {
        src: "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/tt3kmf0p_0FB7FE96-C940-4F9B-87DF-C29E988B00E6.PNG",
        alt: "Vibrant private event buffet styled by Empire Jamaica Fusion",
        span: "md:col-span-6 md:row-span-2 aspect-square md:aspect-[4/5]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/so154t3e_4D544B4D-5ED1-4118-B68A-2CABF55656D8%202.PNG",
        alt: "Elegant catering buffet with floral centerpiece for a private event",
        span: "md:col-span-6 aspect-[4/3]",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/zz8oh899_A99AA3D4-A647-4577-A454-4AACC94A37F1%202.PNG",
        alt: "Garlic shrimp plated for a private dining course",
        span: "md:col-span-3 aspect-square",
    },
    {
        src: "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/wfwhbttq_20E119FE-48F8-4837-A259-B87021DF969B.PNG",
        alt: "Braised oxtail plated for a private dinner",
        span: "md:col-span-3 aspect-square",
    },
];

export const STATS = [
    { value: "5 Years", label: "Serving the Hudson Valley", note: "" },
    { value: "4.8★", label: "Guest Satisfaction", note: "186 verified Google reviews" },
    { value: "100%", label: "Authentic Caribbean Hospitality", note: "" },
];

export const INCLUDES = [
    "Reserved private dining room",
    "Custom-curated Caribbean menu",
    "Dedicated event host",
    "Uniformed plating & service staff",
    "Beverage pairings & non-alcoholic options",
    "Vegan, gluten-free & dietary accommodations",
];

export const OCCASION_OPTIONS = [
    "Birthday",
    "Anniversary",
    "Engagement",
    "Family Reunion",
    "Retirement",
    "Memorial",
    "Holiday Dinner",
    "Other",
];
